<template>
    <div id="center">
        <div id="dmap" style="height:6.5rem;"></div>
        <div style="width: 1.5rem;position: absolute;top: 1.2rem">
            <div style="height: 1rem" v-for="(item, index) in cardData" :key="index">
                <dv-border-box-9>
                    <div style="display: flex;padding: 0.17rem 0.12rem">
                        <div>
                            <img src="../../../img/on_normal.png" style="width: 0.6rem;height: 0.6rem" v-if="item.name=='在线正常'">
                            <img src="../../../img/on_error.png" style="width: 0.6rem;height: 0.6rem" v-else-if="item.name=='在线异常'">
                            <img src="../../../img/off_normal.png" style="width: 0.6rem;height: 0.6rem" v-else-if="item.name=='离线正常'">
                            <img src="../../../img/off_error.png" style="width: 0.6rem;height: 0.6rem" v-else-if="item.name=='离线异常'">
                            <img src="../../../img/un_state.png" style="width: 0.6rem;height: 0.6rem" v-else-if="item.name=='未投运'">
                        </div>
                        <div style="margin-top: 0.1rem;color: #5cd9e8">
                            <div>{{item.name}}</div>
                            <div style="margin-top: 0.1rem;font-weight: bold;text-align: center">{{item.val}}</div>
                        </div>
                    </div>
                </dv-border-box-9>

            </div>


        </div>
    </div>
</template>

<script>
  import echartMixins from "@/utils/resizeMixins";
  // 显示中国地图

  export default {
    data() {
      return {
        chart: null,
      };
    },
    props:{
      location: Array,
      dmapFrom: Array,
      cardData: Array
    },
    mixins: [echartMixins],
    mounted() {
      this.draw();
    },
    methods: {
      draw() {
        // 基于准备好的dom，初始化echarts实例

        this.chart = this.$echarts.init(document.getElementById("dmap"));

        let option = {
          //  鼠标提示
          tooltip : {
            trigger: 'item',
            formatter : function(params){
              var val = params.data.value
              console.log(val)
              return val[2]
            },
          },
          // 地图样式
          geo: {
            map: 'china',
            roam: true, // 是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
            aspectScale: 0.75,
            zoom: 1.20,
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: '#00a0c9'
                }
              },
              emphasis: { // 对应的鼠标悬浮效果
                show: false,
                textStyle: {
                  color: "#00a0c9"
                },
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#07304b',
                borderColor: '#0066ba',
                shadowBlur: 10,
                shadowColor: 'rgba(0,245,255,.5)',
                // shadowOffsetX: 10,
                // shadowOffsetY: 1,
              },
              emphasis: {
                borderWidth: 0,
                borderColor: '#0066ba',
                areaColor: "#0494e1",
                shadowColor: 'rgba(0, 0, 0, 0.5)',

              }
            }
          },
          series: [
            {
              type:'effectScatter',
              coordinateSystem: 'geo',
              zlevel: 15,
              symbolSize:16,
              rippleEffect: {
                period: 4, brushType: 'stroke', scale: 6
              },
              itemStyle:{
                color:'#FF7F24',
                opacity:1
              },
              data:[[118.26982,24.992072]]
            },
            {
              type:'effectScatter',
              coordinateSystem: 'geo',
              zlevel: 15,
              symbolSize:9,
              rippleEffect: {
                period: 6, brushType: 'stroke', scale: 4
              },
              itemStyle:{
                color:'#00BFFF',
                opacity:0.8
              },
              data: this.dmapFrom

            },
            {
              type: 'lines',
              zlevel: 10,
              effect: {
                show: true,
                period: 6,
                trailLength: 0.7,
                color: 'red',
                symbolSize: 3,
              },
              lineStyle: {
                normal: {
                  color: '#a6c84c',
                  width: 0,
                  curveness: 0.4
                }
              },
              data: this.location,

            },
          ]
        };
        this.chart.setOption(option);
      }
    },
    destroyed() {
      window.onresize = null;
    }
  };
</script>

<style lang="scss">


</style>
